import React, { useState } from "react";
import { Tooltip, TooltipProps, ClickAwayListener } from "@mui/material";
import { dashboardTooltipProps } from "../../styles";

interface IDashboardTooltipProps extends Omit<TooltipProps, "children"> {
  children: React.ReactElement;
  containerStyle?: React.CSSProperties;
}

export function DashboardTooltip({
  children,
  title,
  placement = "top",
  containerStyle,
  ...rest
}: IDashboardTooltipProps) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleToggle = (e: React.MouseEvent | React.TouchEvent) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <span
        onClick={handleToggle}
        style={{
          display: "inline-flex",
          cursor: "pointer",
          WebkitTapHighlightColor: "transparent",
          ...containerStyle,
        }}
      >
        <Tooltip
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          disableTouchListener
          title={title}
          arrow
          placement={placement}
          componentsProps={dashboardTooltipProps}
          {...rest}
        >
          {children}
        </Tooltip>
      </span>
    </ClickAwayListener>
  );
}
